import { render, staticRenderFns } from "./employment-contract-view-logs.vue?vue&type=template&id=2b62be59&scoped=true"
import script from "./employment-contract-view-logs.vue?vue&type=script&lang=js"
export * from "./employment-contract-view-logs.vue?vue&type=script&lang=js"
import style0 from "./employment-contract-view-logs.vue?vue&type=style&index=0&id=2b62be59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b62be59",
  null
  
)

export default component.exports